export default {
  massEnable: 'Activer les règles d\'inactivité',
  massDisable: 'Désactiver les règles d\'inactivité',
};
